import NetworkText from 'modules/Modals/NetworkText/NetworkText'

export default NetworkText
